import {HTH} from "../../HTH";
import {HTHGameMode} from "../../server/HTHGameMode";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTHSound} from "../../sound/HTHSound";
import {HTHHelper} from "../../utils/HTHHelper";

export class HTHFSOutroPresentation implements SimplePresentation {
    name: string = "HTHFSOutroPresentation";

    shouldRun(): boolean {
        return !HTH.model.isNormal && HTH.model.mode !== HTHGameMode.NORMAL_AVALANCHE && (HTH.model.isNextNormal || HTH.model.nextMode === HTHGameMode.EXTRA_SPIN) && !HTH.model.data.isExtraSpin && !HTH.model.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const startOutroTL: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();
        HTH.keypadPlugin.setZeroBetSpinCounter(-1);
        const totalWin: number = HTH.model.gameData.accumulatedRoundWin,
            playedBet: number = HTHHelper.getBuyFeaturePrice(),
            isFsBad: boolean = totalWin <= playedBet * 1.1;
        // defining new ratio of 1.1 to be treated as bad outro

        startOutroTL.to(this, {duration: 0.5});
        if (isFsBad) {
            startOutroTL.add(() => {
                HTHSound.playTrack(HTHSound.FS_END_BAD);
                HTHSound.switchMusic({name: HTHSound.BONUS_OUTRO});
            }, 0.5);
        } else {
            startOutroTL.add(() => {
                HTHSound.playTrack(HTHSound.FS_END_GOOD);
                HTHSound.switchMusic({name: HTHSound.BONUS_OUTRO_GOOD});
            }, 0.5);
        }
        startOutroTL.add(HTH.fsOutroView.showFSOutro(), 0.5);
        startOutroTL.add(HTH.transitionView.enableButton(() => this.complete(controller)));
    }

    public complete(controller: SimplePresentationRunnerController): void {
        const endOutroTL: gsap.core.Timeline = gsap.timeline();
        endOutroTL.add(() => {
            HTHSound.playTrack(HTHSound.BONUS_OUTRO_ENDS);
            HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
        }, 0);
        endOutroTL.add(HTH.fsOutroView.hideFSOutro(), 0);
        endOutroTL.add(() => {
            HTH.keypadPlugin.show();
            controller.setSkipCallback();
            controller.finish();
        }, ">");
    }
}